import { render, staticRenderFns } from "./PuntoVentaForm.vue?vue&type=template&id=2cffc55b&"
import script from "./PuntoVentaForm.vue?vue&type=script&lang=js&"
export * from "./PuntoVentaForm.vue?vue&type=script&lang=js&"
import style0 from "./PuntoVentaForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports